import { frontendURL } from 'dashboard/helper/URLHelper';
import CrmPipelineSettings from './pages/CrmPipelineSettings.vue';
import CrmKanban from './pages/CrmKanban.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/crm'),
      name: 'crm_kanban',
      meta: {
        permissions: [
          'administrator',
          'agent',
          'conversation_manage',
          'conversation_unassigned_manage',
          'conversation_participating_manage',
        ],
      },
      component: CrmKanban,
    },
    {
      path: frontendURL('accounts/:accountId/crm/settings'),
      name: 'crm_pipeline_settings',
      meta: {
        permissions: ['administrator'],
      },
      component: CrmPipelineSettings,
    },
  ],
};
